import classNames from 'clsx';
import React from 'react';
import { useField } from 'react-final-form';
import { useSelector } from 'react-redux';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import Translation from '@swf/components/Translation/Translation';
import { select } from '@swf/core/store';

import { useNumberFromIntl } from '../../../../../../hooks/useNumberFromIntl';
import { calculatePotentialReturns } from '../../../../../../utils/calculatePotentialReturns';

import { TXTWCL_Potential_ReturnsX_N0, TXTWCL_n_a } from './PotentialReturn.messages.json';
import styles from './PotentialReturn.scss';

interface Props {
  numberOfLines: number;
  returnFactor?: number;
  placeReturnFactor?: number;
  fieldName: string;
  eachWaySelected?: boolean;
  haveOddsChanged?: boolean;
  shouldDisplayPotentialReturn?: boolean;
}

const PotentialReturn: React.FC<Props> = ({
  numberOfLines,
  returnFactor,
  eachWaySelected,
  placeReturnFactor,
  fieldName,
  haveOddsChanged,
  shouldDisplayPotentialReturn
}) => {
  const { input } = useField(fieldName);
  const hasAutoAcceptEnabled = useSelector(select.account.hasAutoAcceptEnabled);
  const getNumberFromIntl = useNumberFromIntl();

  const { stakePerLineParsed, freeBet } = input.value;

  const isFreeBet = !!freeBet?.length;
  const stakePerLine = getNumberFromIntl(stakePerLineParsed);
  const winPotentialReturn = calculatePotentialReturns({
    stake: stakePerLine,
    returnFactor: returnFactor || 0,
    numberOfLines,
    isFreeBet
  });
  const placePotentialReturn = eachWaySelected
    ? calculatePotentialReturns({
        stake: stakePerLine,
        returnFactor: placeReturnFactor || 0,
        numberOfLines,
        isFreeBet
      })
    : 0;
  const allPotentialReturn = winPotentialReturn + placePotentialReturn;

  return (
    <p className={styles.returns}>
      <Translation
        {...TXTWCL_Potential_ReturnsX_N0}
        values={{
          0: shouldDisplayPotentialReturn ? (
            <span
              className={classNames(
                haveOddsChanged && !hasAutoAcceptEnabled && allPotentialReturn > 0
                  ? styles.returnValueOddsChanged
                  : styles.returnValue
              )}
            >
              <CurrencyAmount value={allPotentialReturn} />
            </span>
          ) : (
            <Translation {...TXTWCL_n_a} />
          )
        }}
      />
    </p>
  );
};

export default PotentialReturn;
